import service from "../util/link"
import url from "../util/apiurl"


/**
 * 设备日志请求
 */
export function orderinfo() {
    return new Promise((resolve, reject) => {
        service.request({
            url: url.order,
            method: "get",

        }).then((ok) => {
            resolve(ok)
        }).catch((err) => {
            reject(err)
        })
    })
}
export function orderpages(obj) {
    return new Promise((resolve, reject) => {
        service.request({
            url: url.order,
            method: "get",
            params: {
                page: obj
            }
        }).then((ok) => {
            resolve(ok)
        }).catch((err) => {
            reject(err)
        })
    })
}
export function orderseach(companyid, startTime, endTime,page) {
    return new Promise((resolve, reject) => {
        service.request({
            url: url.order,
            method: "get",
            params: {
                companyid: (typeof (companyid) == 'number') || (typeof (companyid) == 'string') ? companyid : "",
                startTime: (typeof (startTime) == 'number') || (typeof (startTime) == 'string') ? startTime : "",
                endTime: (typeof (endTime) == 'number') || (typeof (endTime) == 'string') ? endTime : "",
                page: (typeof (page) == 'number') || (typeof (page) == 'string') ? page : ""
            }
        }).then((ok) => {
            resolve(ok)
        }).catch((err) => {
            reject(err)
        })
    })
}